import Swiper from "swiper";
import {Autoplay, FreeMode} from "swiper/modules";


document.addEventListener('DOMContentLoaded', () => {

    const postsSlider = new Swiper('.swiper-posts', {
        autoplay: {
            delay:1
        },
        speed:12000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 320px
            640: {
                slidesPerView: 1.5,
                spaceBetween: 20
            },
            // when window width is >= 480px
            760: {
                slidesPerView: 1.8,
                spaceBetween: 30
            },
            960: {
                slidesPerView: 2.4,
                spaceBetween: 30
            },
            // when window width is >= 640px
            1280: {
                slidesPerView: 2.8,
                spaceBetween: 40
            },
            1360: {
                slidesPerView: 3.2,
                spaceBetween: 40
            }
        },
        loop: true,
        centeredSlides: false,
        spaceBetween: 20,
        freeMode: true,
        modules: [Autoplay, FreeMode],
    });
});
